export default {
  inject: {
    ad_expose_tracker: {
      default: null
    }
  },
  data: function () {
    return {
      ad_expose_bound_els: []
    }
  },
  methods: {
    bindAdExposeHandle: function (el, flow_area, item) {
      if (!this.ad_expose_tracker || !el || !flow_area) return
      this.ad_expose_tracker.observe(el, flow_area, item)
      if (this.ad_expose_bound_els.indexOf(el) < 0) {
        this.ad_expose_bound_els.push(el)
      }
    },
    bindAdExposeCarouselHandle: function (el, opt) {
      if (!this.ad_expose_tracker || !el || !opt) return
      this.ad_expose_tracker.observeCarousel(el, opt)
      if (this.ad_expose_bound_els.indexOf(el) < 0) {
        this.ad_expose_bound_els.push(el)
      }
    },
    notifyAdExposeCarouselHandle: function (el) {
      if (!this.ad_expose_tracker || !el) return
      this.ad_expose_tracker.onCarouselChange(el)
    },
    clearAdExposeHandle: function () {
      if (!this.ad_expose_tracker) return
      var els = this.ad_expose_bound_els
      for (var i = 0; i < els.length; i++) {
        this.ad_expose_tracker.unobserve(els[i])
      }
      this.ad_expose_bound_els = []
    },
    scheduleAdExposeBindHandle: function (bind_fn) {
      var that = this
      this.clearAdExposeHandle()
      this.$nextTick(function () {
        if (typeof bind_fn === 'function') bind_fn.call(that)
      })
    }
  },
  beforeDestroy: function () {
    this.clearAdExposeHandle()
  }
}



// WEBPACK FOOTER //
// ./src/components/homepage/js/adExposeMixin.js